export default __webpack_public_path__ + "static/05-8977a1e551114fc9ed06c503e28181a6.jpg";